module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Babies Hospital of New York")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Great academic medical centers and hospitals are composed of health care providers, physicians, nurses, learners, philanthropists, courageous children, parents, and families. The Babies Hospital is such an institution, replete with historical richness, innovation, discovery, and important medical firsts. Founded in a brownstone on the east side of Manhattan in 1887 by sisters, Drs. Sarah and Julia McNutt, the Babies Hospital was the first hospital in New York City and the fourth oldest in the United States exclusively for children. The legacy of the hospital was advanced by L. Emmett Holt, MD, the first chair of the Department of Pediatrics, scholar, mentor, and author of "), _c('i', [_vm._v("Holt’s Diseases of Infancy and Childhood")]), _vm._v(". Holt’s later successor, Rustin McIntosh, created subspecialty services in hematology-oncology, radiology, and neurology among others during his almost-30-year tenure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The inspiration for "), _c('i', [_vm._v("The Babies Hospital of New York")]), _vm._v(" is Jordan S. Orange, MD, PhD, the Reuben S. Carpentier Professor; chair of the Department of Pediatrics, Columbia University Vagelos College of Physicians and Surgeons; and pediatrician in-chief of NewYork-Presbyterian Morgan Stanley Children’s Hospital. His penchant for history and belief that our future is rooted in our past made this book possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless otherwise noted, all images appear courtesy of Archives & Special Collections of the Augustus C. Long Health Sciences Library, Columbia University Irving Medical Center.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Members of the NewYork-Presbyterian Hospital development office and special events team of the Morgan Stanley Children’s Hospital also provided photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Royalties from "), _c('i', [_vm._v("The Babies Hospital of New York")]), _vm._v(" will be donated to Columbia Children’s Health.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Michael Weiner, MD")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Stephen E. Novak, head of Archives & Special Collections, A.C. Long Health Sciences Library")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 78
// module chunks = 0